import { Service } from '@/services/api';

export interface EpicLastSync {
  lastSyncedAt: string | null;
}

class EpicService extends Service {
  async getLastSync(): Promise<EpicLastSync> {
    return this.get<EpicLastSync>('/v2/epic/last-sync').then(this.handleResponse);
  }
}

export default new EpicService();
